import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "mx-auto w-full max-w-sm lg:w-96" }
const _hoisted_2 = { class: "mt-8 text-2xl/9 font-bold tracking-tight text-gray-900" }
const _hoisted_3 = { class: "mt-2 text-sm/6 text-gray-500" }
const _hoisted_4 = {
  key: 0,
  class: "rounded-md bg-green-50 mt-4 p-4"
}
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "ml-3" }
const _hoisted_7 = { class: "text-sm font-medium text-green-800" }
const _hoisted_8 = {
  key: 1,
  class: "mt-10"
}
const _hoisted_9 = {
  for: "email",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_10 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_11 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "email-error"
}
const _hoisted_12 = {
  type: "submit",
  class: "flex w-full justify-center rounded-md bg-royal-blue-500 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-royal-blue-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royal-blue-500 cursor-pointer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ExclamationCircleIcon = _resolveComponent("ExclamationCircleIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_router_link, { to: "/login" }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createElementVNode("img", {
            class: "h-10 w-auto",
            src: _imports_0,
            alt: "Gallera"
          }, null, -1)
        ])),
        _: 1
      }),
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('auth_send_reset.title')), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('auth_send_reset.description')), 1)
    ]),
    (_ctx.isSuccess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "shrink-0" }, [
              _createElementVNode("svg", {
                class: "size-5 text-green-400",
                viewBox: "0 0 20 20",
                fill: "currentColor",
                "aria-hidden": "true",
                "data-slot": "icon"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z",
                  "clip-rule": "evenodd"
                })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('auth_send_reset.success')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isSuccess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", null, [
            _createElementVNode("form", {
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.store && _ctx.store(...args)), ["prevent"])),
              class: "space-y-6"
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('auth_send_reset.email')), 1),
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    id: "email",
                    type: "email",
                    class: _normalizeClass({
                                    'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-royal-blue-600 sm:text-sm/6': true,
                                    'col-start-1 row-start-1 block w-full text-red-400 outline-red-400': _ctx.hasError('email'),
                                }),
                    name: "email",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event)),
                    required: "",
                    autocomplete: "email",
                    autofocus: ""
                  }, null, 2), [
                    [_vModelText, _ctx.form.email]
                  ]),
                  (_ctx.hasError('email'))
                    ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                        key: 0,
                        class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                        "aria-hidden": "true"
                      }))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.hasError('email'))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.getError('email')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", _hoisted_12, _toDisplayString(_ctx.$t('auth_send_reset.send_button')), 1)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}